/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truck': {
    width: 274,
    height: 219,
    viewBox: '0 0 274 219',
    data: '<defs/><path pid="0" id="truck" class="cls-1" d="M1579.6 616h-137a27.416 27.416 0 0 0-27.4 27.375v13.688h-27.4a54.835 54.835 0 0 0-54.8 54.75v82.125a13.692 13.692 0 0 0 13.7 13.687h29.93a40.866 40.866 0 0 0 77.15 0h46.15a40.866 40.866 0 0 0 77.15 0h16.22a13.692 13.692 0 0 0 13.7-13.687V643.375A27.416 27.416 0 0 0 1579.6 616zm0 27.375V780.25h-2.52a40.873 40.873 0 0 0-77.16 0h-46.14a40.941 40.941 0 0 0-11.18-16.689V643.375h137zm-219.2 68.438a27.415 27.415 0 0 1 27.4-27.375h27.4v68.437a41.047 41.047 0 0 0-38.58 27.375h-16.22v-68.437zm54.8 95.812a13.688 13.688 0 1 1 13.7-13.687 13.713 13.713 0 0 1-13.7 13.687zm123.3 0a13.688 13.688 0 1 1 13.7-13.687 13.713 13.713 0 0 1-13.7 13.687zm-137-109.5h-27.4V725.5h27.4v-27.375z" transform="translate(-1333 -616)"/>'
  }
})
